module.exports = __webpack_public_path__ + "static/homeFlexiLoading-b9f60ed2732850a586bced1e1ee898c7.gif";